/*
 * @Author: Raeesaa Metkari
 * @Date: 2020-03-20 17:44:58
 * @Last Modified by: Raeesaa Metkari
 * @Last Modified time: 2020-03-27 14:29:15
 */

export enum WholesaleSettingsSection {
  Settings = 'settings',
  Clients = 'clients',
  Discounts = 'discounts',
  WholesaleSettings = 'wholesaleSettings',
  RetailSettings = 'retailSettings',
  Stores = 'stores',
  Memberships = 'memberships',
  MarkupOrDiscount = 'markupOrDiscount',
  SalesPeriods = 'salesPeriods',
  Zones = 'zones',
  ManageData = 'manageData',
  Prices = 'prices',
  RangePlans = 'rangePlans',
  BuyTarget = 'buyTarget',
  ClientBudget = 'clientBudget',
  BuyingSessionGroups = 'buyingSessionGroups',
  ExcelConfiguration = 'excelConfiguration'
}

export enum WholesaleSettingsSectionDisplayName {
  Settings = 'General Settings',
  Clients = 'Clients',
  Discounts = 'Discounts',
  WholesaleSettings = 'Wholesale Settings',
  RetailSettings = 'Retail Settings',
  Stores = 'Stores',
  Memberships = 'Memberships',
  MarkupOrDiscount = 'Markup/Discount',
  SalesPeriods = 'Sales Periods',
  Zones = 'Zones',
  MangeData = 'Manage Data',
  Prices = 'Prices',
  RangePlans = 'Range Plans',
  BuyTarget = 'Buy Target',
  ClientBudget = 'Client Budget',
  BuyingSessionGroups = 'Buying Session Groups',
  ProductCards = 'Product Cards',
  ProductFilterSort = 'Sort/Filter/Group/Search',
  ProductDetaiConfiguration = 'Product Detail Configuration',
  listViewTable = 'List View Table',
  ExcelConfiguration = 'Excel Configuration'
}

export enum WholesaleSettingsSectionToolbarTitle {
  settings = 'General Settings',
  clients = 'Client Settings',
  zones = 'Zone Settings',
  discounts = 'DISCOUNTS'
}

export enum WholesaleSettingsView {
  Membership = 'membership',
  Configuration = 'configuration',
  Branding = 'branding',
  Localization = 'localization',
  Clusters = 'clusters',
  ClusterGroup = 'clusterGroup',
  Worldwide = 'worldwide',
  SeasonsSyncUp = 'seasonsSyncUp',
  GlobalDataSync = 'globalDataSync',
  ActivitySelection = 'activitySelection',
  Discounts = 'discounts',
  Memberships = 'memberships',
  MarkupOrDiscount = 'markupOrDiscount',
  RangePlans = 'rangePlans',
  BuyTarget = 'buyTarget',
  ClientBudget = 'clientBudget',
  BuyingSessionGroups = 'buyingSessionGroups',
  ProductCardConfiguration = 'productCardConfiguration',
  ProductFilterSort = 'productFilterSort',
  ProductDetaiConfiguration = 'productDetailConfiguration',
  ListViewTable = 'listViewTable',
  ExcelConfiguration = 'excelConfiguration'
}

export enum WholesaleSettingsViewDisplayName {
  Membership = 'Membership',
  Configuration = 'Configuration',
  Branding = 'Branding',
  Localization = 'Localization',
  Clusters = 'Clusters',
  ClusterGroup = 'Cluster Group',
  Worldwide = 'WORLDWIDE',
  SeasonsSyncUp = 'Seasons Sync Up',
  GlobalDataSync = 'Sync Data',
  Discounts = 'Discounts',
  ActivitySelection = 'Category Selection',
  ProductCards = 'Product Cards',
  ProductFilterSort = 'Sort/Filter/Group/Search',
  ProductDetaiConfiguration = 'Product Detail Configuration',
  ListViewTable = 'List View Table',
  ExcelConfiguration = 'Excel Configuration'
}

/**
 * NOTE: In case view toolbar title is not found, display
 * section toolbar title instead
 */
export enum WholesaleSettingsViewToolbarTitle {
  memberships = 'Memberships',
  clusters = 'Clusters',
  configuration = 'Configuration',
  branding = 'Branding',
  localization = 'Localization',
  clusterGroup = 'Cluster Group',
  seasonsSyncUp = 'Seasons Sync Up',
  globalDataSync = 'Sync Data',
  activitySelection = 'Category Selection',
  discounts = 'Discounts',
  markup = 'Markup',
  markupOrDiscount = 'Markup/Discount',
  prices = 'Prices',
  rangePlans = 'Range Plans',
  buyTarget = 'Buy Target',
  clientBudget = 'Client Budget',
  buyingSessionGroups = 'Buying Session Groups',
  productCardConfiguration = 'Product Cards',
  productFilterSort = 'Sort/Filter/Group/Search Configuration',
  productDetailConfiguration = 'Product Detail Configuration',
  listViewTable = 'List View Table',
  excelConfiguration = 'Excel Configuration'
}
